import LoadingAnimation from "@assets/svg/LoadingAnimation";
import Button from "@components/button/button";
import { login } from "@endpoints/auth.service";
import { linkAccount } from "@endpoints/user.service";
import { loginUser } from "@store/actions/auth.action";
import regexList from "@utils/regexList";
import { colors } from "@utils/theme";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

const LoginModal = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const {
    control,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      openLoginModel: false,
      isLoading: false,
    },
  });
  const fields = watch();

  const [accountLinking, setAccountLinking] = useState(false);

  const handleLogin = async (fields) => {
    try {
      setValue("isLoading", true);
      const { data } = await login(fields);

      setAccountLinking(true);
      const { data: _data } = await linkAccount(data.token);

      dispatch(loginUser(_data));
      // if (data?.user?.userType === userTypes.CANDIDATE) {
      //   await fetchCandidateDetails(data);
      // } else if (data?.user?.userType === userTypes.REFERRAL_AMBASSADOR) {
      //
      // }
      setValue("openLoginModel", false);
      window.location.reload();
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      setValue("isLoading", false);
    }
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50  flex justify-center items-center z-50">
      <div className="flex flex-col gap-6 bg-white rounded-lg px-10 min-w-[25%] py-8">
        <label className="font-semibold text-3xl text-center mb-2">Login</label>
        <label className="text-light-black text-center font-medium">
          Please login to access your account
        </label>
        <form
          className="flex flex-col w-full pt-5"
          onSubmit={handleSubmit(handleLogin)}
        >
          {/* @ts-ignore */}
          <CustomInput
            label={"Email"}
            name="email"
            placeholder={"Enter your Email"}
            rules={{
              required: "This field is required.",
              pattern: {
                value: regexList.email,
                message: "Please enter a valid email.",
              },
            }}
            control={control}
            errors={errors}
          />
          <div className="h-6" />
          {/* @ts-ignore */}
          <CustomInput
            label={"Password"}
            placeholder={"Enter your Password"}
            name="password"
            rules={{
              required: "This field is required.",
              pattern: {
                value: regexList.password,
                message: "Please enter a valid password.",
              },
            }}
            control={control}
            errors={errors}
          />
          <div className="flex gap-3">
            <Button
              type="submit"
              variant="outline"
              color={colors.TextPrimary}
              onClick={() => setValue("openLoginModel", false)}
              className="flex flex-1 items-center justify-center rounded-full mt-10 py-3"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-secondary flex flex-1 items-center justify-center flex-row rounded-full mt-10 py-3"
            >
              <div className="flex">
                {fields?.isLoading && <LoadingAnimation />}
                Login
              </div>
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;
